import { Component, EventEmitter, Inject, Input, OnInit, Output } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { TipoMensagem } from 'app/requisitorio/model/tipo-mensagem';

@Component({
  selector: 'pje-mensagem-dialog',
  templateUrl: './mensagem-dialog.component.html',
  styleUrls: ['./mensagem-dialog.component.scss']
})
export class MensagemDialogComponent implements OnInit {

  opcoes: {
    mensagens: string[],
    checarProximasMensagem: boolean,
    tipo: TipoMensagem,
    labels: string[]
  };
  @Output() emiteResposta = new EventEmitter();

  constructor(
    public dialogRef: MatDialogRef<MensagemDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any) {
    this.opcoes = data;
  }

  ngOnInit() {
    if(!this.opcoes.labels){
      if(this.opcoes.tipo === TipoMensagem.CONFIRMACAO){
        this.opcoes.labels = ['','OK'];
      } else if(this.opcoes.tipo === TipoMensagem.AVISO){
        this.opcoes.labels = ['NÃO','SIM'];
      }
      else if(this.opcoes.tipo === TipoMensagem.ERRO){
        this.opcoes.labels = ['','CONTINUAR'];
      }

    }
  }


  confirmar() {
    if(this.opcoes.mensagens.length == 1){
      this.opcoes.checarProximasMensagem = false;
    }
    if (!this.opcoes.checarProximasMensagem){
            this.dialogRef.close(true);
    }
    this.opcoes.mensagens = this.opcoes.mensagens.slice(1,this.opcoes.mensagens.length);
  }

  cancelar() {
    this.dialogRef.close(false);
  }


}
